import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getVaultAccountDetailsPath = (id = ':id') => urlHelper(`/my-vault/${id}`);
